<template>
    <div class="row">
        <div class="col-12">
            <b-card no-body class="card__no_padding">
                <b-tabs card>
                    <b-tab title="Temas e planejamento" active class="tab__no_padding">
                        <planejamento-tema  :form="form" @save="savePlanejamento" ref="tema"/>
                    </b-tab>
                    <b-tab title="Estimativa de custos" class="tab__no_padding">
                        <planejamento-estimativa :form="form" @save="savePlanejamento" ref="estimativas" />
                    </b-tab>
                </b-tabs>
            </b-card>
        </div>

        <div class="col-12 mt-4" v-if="versions.length">
            <h5>Versões do planejamento</h5>
        </div>
        <div class="col-12 mt-1" v-if="versions.length" >
            <b-card no-body class="card__no_padding card__bordered card__no_shadow">

                <template v-for="(version,i) in versions">
                    <div :key="version.planejamentoEstrategicoAnteriorId">
                        <b-card-header @click="showAccordion(version)"  class="p-2" role="tab">
                            <div class="d-flex">
                                <div>Versão {{i+1}}</div>
                                <i class="ti ti-angle-down dd-arrow ml-auto hide-text"></i>
                            </div>
                        </b-card-header>
                        <b-collapse :id="`${i}`" v-model="version.visible" >
                            <b-tabs card>
                                    <b-tab title="Temas e planejamento" active class="tab__no_padding">
                                        <planejamento-tema  :form="version" disabled/>
                                    </b-tab>
                                    <b-tab title="Estimativa de custos" class="tab__no_padding">
                                        <planejamento-estimativa :form="version" disabled />
                                    </b-tab>
                                </b-tabs>
                        </b-collapse>
                    </div>
                </template>                
                
            </b-card>
            
        </div>
    </div>
</template>
<script>


import Swal from "sweetalert2";

import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import { START_LOADING, STOP_LOADING } from "@/store/Store";

import PlanejamentoTema from "./PlanejamentoTema.vue";
import PlanejamentoEstimativa from "./PlanejamentoEstimativa.vue";

import PlanejamentoService from "@/common/services/planejamento/planejamento.service";
import helpers from "@/common/utils/helpers";

export default {
    props: ["id"],
    components: {
        PlanejamentoTema,
        PlanejamentoEstimativa
    },
    data  : () => ({
        form: {
            planejamentoEstrategicoAnteriorId: null,
            projecaoFinanceiraId : null,
            inicio: null,
            fim: null,
            selecaoTemaSubtemas :[
                {   
                    temaSelecionado : {
                        temaId: null,
                        descricaoPersonalizada: null,
                    },
                    subtemas :[],
                    subtemasSelecionados: []
                }
            ],
            estimativas : [
                {
                    fase: null,
                    valor: 0,
                    inicio: null,
                    fim: null,
                    quantidadeProjetos : 0
                }
            ]
        },
        versions: []
        
    }),
    methods: {
        showAccordion : function(version){
            let status = !version.visible;
            this.versions.forEach(v => {
                v.visible = false;
            });
          
          if(status)
                version.visible = status;
        },

        formatPlanejamento: function(planejamento){
            let response = {
                planejamentoEstrategicoAnteriorId: planejamento.id,
                projecaoFinanceiraId : planejamento.projecaoFinanceiraId,
                inicio: helpers.formatarDataBr(planejamento.inicio),
                fim: helpers.formatarDataBr(planejamento.fim),
                selecaoTemaSubtemas: planejamento.selecaoTemaSubtemas.map(el =>{
                    let elemento = {
                        temaSelecionado : {
                            temaId: el.temaSelecionado.tema.id,
                            descricaoPersonalizada: el.temaSelecionado.descricaoPersonalizada,
                        },
                        subtemas : el.subtemasSelecionados.map(sub => sub.subtema.id),
                        subtemasSelecionados: el.subtemasSelecionados.map(sub => {
                            let subtema = {
                                subtemaId: sub.subtema.id,
                                descricaoPersonalizada: sub.descricaoPersonalizada
                            }
                            return subtema;
                        })
                    }
                    return elemento;
                }),
                estimativas : planejamento.estimativas.map(el => {
                    let estimativa = {
                        fase: el.fase,
                        valor: helpers.formatarValor(el.valor),
                        inicio: helpers.formatarDataBr(el.inicio),
                        fim: helpers.formatarDataBr(el.fim),
                        quantidadeProjetos : el.quantidadeProjetos
                    }
                    return estimativa
                })
            };

            return response;

        },

        recursiveFetchVersions: function(planejamento){
            if(planejamento.planejamentoEstrategicoAnterior){
                this.recursiveFetchVersions(planejamento.planejamentoEstrategicoAnterior);
                this.versions.push(this.formatPlanejamento(planejamento.planejamentoEstrategicoAnterior));
            }
        },

        fetchPlanejamento: function(id){
            PlanejamentoService.get(id).then(res => {
                let response = res.data.data;

                this.form = this.formatPlanejamento(response);

                this.recursiveFetchVersions(response);
            });
        },
        
        savePlanejamento : function(){
            let validTema = this.$refs.tema.validateState('form-');
            let validEstimativas = this.$refs.estimativas.validateState();
            if(!validTema || !validEstimativas)
                return false;
                
            Swal.fire({
                title: "Aviso",
                text: "Deseja salvar o planejamento?",
                icon: "warning",
                showDenyButton: true,
                confirmButtonText: 'Sim',
                denyButtonText: `Não`
            }).then((result) =>{
                if (result.isConfirmed) {

                    let form = Object.assign({}, this.form);            
                    form.estimativas = form.estimativas.map(el =>{
                        let element = Object.assign({}, el);
                        element.valor = el.valor.replace('R$ ', '').replace('.','').replace(',','.');
                        return element;
                    });

                    form.selecaoTemaSubtemas = form.selecaoTemaSubtemas.map(el => {
                        el.subtemasSelecionados = el.subtemas.map(el => {
                            return {
                                subtemaId: el,
                                descricaoPersonalizada : ""
                            }
                        })

                        return el;
                    })

                    this.$store.dispatch(START_LOADING);
                    PlanejamentoService.store(form).then(res => {
                        this.form.planejamentoEstrategicoAnteriorId = res.data.data;
                        
                        Swal.fire({
                            title: "Sucesso",
                            text: "Planejamento salvo com sucesso!",
                            icon: "success",
                        }).then(() => {
                            this.$router.push({name: 'planejamento-estrategico-lista'});
                        });
                    }).catch(err => {
                        Swal.fire({
                            title: "Erro",
                            text: err.response.data.errors,
                            icon: "error",
                        });
                    }).finally(() => {
                        this.$store.dispatch(STOP_LOADING);
                    });

                }
            });

           

        }
    },
    mounted(){
        this.$store.dispatch(DEFINIR_BREADCRUMB, [
            { titulo: 'Planejamento estratégico', to: {name: "planejamento-estrategico-lista"} },
            { titulo: (!this.id ? 'Cadastrar' : 'Versionar') },
        ]);

        if(this.id)
            this.fetchPlanejamento(this.id);
    }
}
</script>
<style>
    
    .table-tab tbody td {
        border: 1px solid #e5e5e5;
    }
</style>